import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home/Home.vue";
import Empresas from "./views/empresas/empresas.vue";
import Produtos from "./views/produtos/produtos.vue";
import Monitoria from "./views/monitoria-produto/monitoria-produto.vue";
import Historico from "./views/monitoria/monitoria.vue";
import Cenario from "./views/cenario/cenario.vue";

import Acesso from "./views/acesso/acesso.vue";
import Login from "./views/login/Login.vue";
import Erro from "./views/Erro.vue";
import TestesProcedures from "./views/testes-procedures/testes-procedures.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/empresas",
      name: "empresas",
      component: Empresas
    },
    {
      path: "/cenario",
      name: "cenario",
      component: Cenario
    },
    {
      path: "/produtos",
      name: "produtos",
      component: Produtos
    },
    {
      path: "/monitoria/:id?",
      name: "monitoria",
      component: Historico
    },
    {
      path: "/monitoria-produto",
      name: "monitoria-produto",
      component: Monitoria
    },
    {
      path: "/testes-procedures",
      name: "testes-procedures",
      component: TestesProcedures
    },
    {
      path: "/acesso",
      name: "acesso",
      component: Acesso
    },
    {
      path: "/validar-login/:id",
      name: "Login",
      component: Login
    },
    {
      path: "/:id",
      name: "RTE",
      component: Home
    },
    {
      path: "/erro/:intErro",
      name: "Erro",
      component: Erro
    }
    // {
    // 	path: '/produtos-monitoria',
    // 	name: 'addProdutos',
    // 	component: () => import('./views/produtos/produtos.vue')
    // },
  ]
});
